"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorSubstituteContractDetailsApiResponseSchema = exports.agendaSlotDoctorSubstituteContractSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const event_schema_1 = require("../global/event.schema");
const add_doctor_substitute_contract_1 = require("./add-doctor-substitute-contract");
exports.agendaSlotDoctorSubstituteContractSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('agenda-slots'),
    attributes: zod_1.z.object({
        startAt: zod_1.z.coerce.date(),
        endAt: zod_1.z.coerce.date(),
        periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
    }),
});
exports.getDoctorSubstituteContractDetailsApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('doctor-substitute-contracts'),
        attributes: zod_1.z.object({
            from: zod_1.z.string(),
            to: zod_1.z.string(),
            retrocessionRate: zod_1.z.number().nullable(),
            documentUrl: zod_1.z.string(),
            doctorSubstituteSignedAt: zod_1.z.coerce.date().nullable(),
            metadata: add_doctor_substitute_contract_1.doctorSubstituteContractMetadata,
            createdAt: zod_1.z.coerce.date(),
        }),
        relationships: zod_1.z.object({
            agendaSlots: (0, api_1.apiEntityRelationshipsSchema)('agenda-slots'),
        }),
    }),
    included: zod_1.z
        .array(exports.agendaSlotDoctorSubstituteContractSchema)
        .optional()
        .default([]),
});
